import Utils from '@/common/utils'
import axios from 'axios'

const headers = {
  'Content-Type': 'application/json',
  Authorization: Utils.setCreditDispersionsAppToken()
}

export default class StpService {
  static getURL () {
    return `${process.env.VUE_APP_API_HOST}/creditDispersions`
  }

  static async getPayerCostCenterByClient (rfc) {
    const baseUrl = this.getURL()
    const { data } = await axios.get(
      `${baseUrl}/api/stp/costCenter/payers/${rfc}`,
      { headers }
    )
    return data
  }

  static async createCostCenter (payload) {
    const baseUrl = this.getURL()
    const { data } = await axios.post(
      `${baseUrl}/api/stp/costCenter/`,
      payload,
      { headers }
    )

    return data
  }

  static async getSTPBalance (payload) {
    const baseUrl = this.getURL()
    const { data } = await axios.post(
      `${baseUrl}/api/stp/clientDispersions/base64`,
      payload,
      { headers }
    )
    return data
  }

  static async sendSTPBalance (payload) {
    const baseUrl = await this.getURL()
    const { data } = await axios.post(
      `${baseUrl}/api/stp/clientDispersions/email`,
      payload,
      { headers }
    )
    return data
  }
}
